<template>
  <div id="nova">
    <MainHeader />

    <!-- Content -->
<!--      class="hidden 2xl:block 2xl:absolute left-0 bottom-0 2xl:top-[56px] 2xl:bottom-auto w-60 px-3 py-8"-->
    <div data-testid="content">
      <div
        class="hidden left-0 bottom-0 w-60 px-3 py-8"
      >
        <MainMenu />
      </div>

<!--        <div class="py-4 px-1 md:py-8 md:px-12 2xl:ml-60 space-y-8">-->
      <div class="py-4 px-0 md:py-8 md:px-12 space-y-8">
        <Breadcrumbs v-if="breadcrumbsEnabled" />

        <FadeTransition>
          <slot />
        </FadeTransition>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import MainHeader from '@/layouts/MainHeader'
import Footer from '@/layouts/Footer'

export default {
  components: {
    MainHeader,
    Footer,
  },

  mounted() {
    Nova.$on('error', this.handleError)
    Nova.$on('token-expired', this.handleTokenExpired)
  },

  beforeUnmount() {
    Nova.$off('error', this.handleError)
    Nova.$off('token-expired', this.handleTokenExpired)
  },

  methods: {
    handleError(message) {
      Nova.error(message)
    },

    handleTokenExpired() {
      // @TODO require Nova._createToast() to support action with link.
      Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'error',
      })

      setTimeout(() => {
        Nova.redirectToLogin()
      }, 5000)
    },
  },

  computed: {
    breadcrumbsEnabled() {
      return Nova.config('breadcrumbsEnabled')
    },
  },
}
</script>
<style src="tailwindcss/components.css" scoped></style>
<style src="tailwindcss/utilities.css" scoped></style>
